// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.PostPage__AsideInfo--deadline-text.expanded{display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;overflow:hidden}`, "",{"version":3,"sources":["webpack://./pages/post/components/AsideInfo/AsideInfo.scss"],"names":[],"mappings":"AAEQ,6CACI,mBAAA,CACA,oBAAA,CACA,2BAAA,CACA,eAAA","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
